<div class="material-panel">
  <div class="title">
    <h3>{{ 'ORDERS.MATERIAL.TITLE' | translate }}</h3>
  </div>

  <form [formGroup]="editMaterialForm">
    <eps-select
      [options]="panelStatus.packingIdEditable ? packingIds : definitions.packing.type"
      formControlName="packingId"
      label="ORDERS.MATERIAL.LABELS.TYPE_PACKING"
      autoSelect
      class="col-12"
      (ngModelChange)="packingIdChanged()"
      [readonly]="!panelStatus.packingIdEditable"
      [labelWidth]="labelWidth"
    ></eps-select>

    <eps-number-input
      formControlName="packingQuantity"
      label="ORDERS.MATERIAL.LABELS.QUANTITY"
      class="col-12"
      (input)="onQuantityChange($event.target.value)"
      [labelWidth]="labelWidth"
    ></eps-number-input>

    <eps-text-input
      formControlName="lineReferenceId"
      [readonly]="!panelStatus.otherFieldsEditable"
      [inlineSuffix]="lineItemValidation.example"
      lineRefValidator
      class="col-12"
      [lineItem]="lineItemValidation"
      label="ORDERS.MATERIAL.LABELS.REFERENCE"
      [required]="!!lineItemValidation?.reference"
      [labelWidth]="labelWidth"
    ></eps-text-input>

    <eps-label-body [labelWidth]="labelWidth" class="col-12" *ngIf="showLineReferenceError || showLineReferenceInitialValidationMessage">
      <span @growInOut class="col-12 col-md-10 error-message">
        <ng-container *ngIf="showLineReferenceInitialValidationMessage">{{initialValidationMsg}}</ng-container>
        <ng-container *ngIf="showLineReferenceError">{{editMaterialForm.get('lineReferenceId').errors?.message}}</ng-container>
      </span>
    </eps-label-body>

    <eps-select
      [options]="definitions.global.brick"
      formControlName="contentId"
      *ngIf="panelStatus.otherFieldsEditable"
      label="ORDERS.MATERIAL.LABELS.CONTENT"
      class="col-12"
      [required]="!!lineItemValidation?.content"
      [readonly]="!panelStatus.otherFieldsEditable"
      [labelWidth]="labelWidth"
    ></eps-select>

    <div class="col-12 buttons save-button">
      <eps-button
        [disabled]="saving || editMaterialForm.invalid || editMaterialForm.get('lineReferenceId').status === 'PENDING'"
        [busy]="saving"
        (buttonClick)="nextClickedFn()"
        buttonIcon="plus"
        label="ORDERS.MATERIAL.BUTTONS.ADD_MATERIAL"
        submit
        *ngIf="panelStatus.isNew"
      ></eps-button>
      <eps-button
        [disabled]="saving || editMaterialForm.invalid"
        [busy]="saving"
        (buttonClick)="nextClickedFn()"
        label="SHARED.BUTTONS.SAVE"
        submit
        *ngIf="panelStatus.isUpdate"
      ></eps-button>
    </div>
  </form>
</div>
